export const ANNUAL_REVENUES = [
  {
    key: 'UpTo100k',
    label: '$0 - $99,999'
  },
  {
    key: 'Between100kAnd250k',
    label: '$100,000 - $249,999'
  },
  {
    key: 'Between250kAnd500k',
    label: '$250,000 - $499,999'
  },
  {
    key: 'Between500kAnd1m',
    label: '$500,000 - $999,999'
  },
  {
    key: 'Between1mAnd5m',
    label: '$1mil - $4,999,999'
  },
  {
    key: 'Over5m',
    label: '$5mil+'
  }
];
